module.exports = __webpack_public_path__ + "img/result_bg1.11a8581d.png";